"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var core_1 = require("@material-ui/core");
var Icon_1 = __importDefault(require("../Icon"));
var useStyles = (0, core_1.makeStyles)(function (theme) { return ({
    icon: {
        width: theme.typography.h5.fontSize,
        height: theme.typography.h5.fontSize,
    },
    button: {
        padding: theme.spacing(0.5)
    }
}); });
var IconButton = function (_a) {
    var _b = _a.classes, classes = _b === void 0 ? {} : _b, color = _a.color, _c = _a.disableFocusRipple, disableFocusRipple = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, disableRipple = _a.disableRipple, edge = _a.edge, _e = _a.size, size = _e === void 0 ? 'medium' : _e, kind = _a.kind, _f = _a.onClick, onClick = _f === void 0 ? function () { } : _f, id = _a.id, children = _a.children;
    var internalClasses = useStyles();
    var _g = classes.icon, iconClasses = _g === void 0 ? {} : _g, _h = classes.button, btnClasses = _h === void 0 ? {} : _h;
    return (react_1.default.createElement(IconButton_1.default, { id: id, classes: __assign(__assign({}, btnClasses), { root: "".concat(internalClasses.button, " ").concat(btnClasses.root || '') }), color: color, disableFocusRipple: disableFocusRipple, disabled: disabled, disableRipple: disableRipple, size: size, edge: edge, onClick: onClick },
        kind && (react_1.default.createElement(Icon_1.default, { classes: __assign(__assign({}, iconClasses), { root: "".concat(internalClasses.icon, " ").concat(iconClasses.root || '') }), kind: kind })),
        children));
};
exports.default = IconButton;
